import React from 'react';
import InfoCircle from 'wix-ui-icons-common/InfoCircle';
import { Checkbox } from 'wix-ui-tpa/Checkbox';
import { Tooltip } from 'wix-ui-tpa/Tooltip';
import { DeviceType } from '../../../../../types/DeviceType';
import { DH } from '../../../../../utils/DataHook';
import { t } from '../../../../../utils/i18n';
import { classes } from './styles.st.css';

export interface SaveCardCheckboxProps {
  isChecked: boolean;
  deviceType: DeviceType;

  onChange(nextIsChecked: boolean): void;
}

export const SaveCardCheckboxView: React.FunctionComponent<SaveCardCheckboxProps> =
  (props) => (
    <div
      className={classes.root}
      data-hook={DH.PaymentMethod.CreditCard.SaveCard.Container}
    >
      <Checkbox
        className={classes.checkbox}
        label={t('cc.saveCard.title')}
        checked={props.isChecked}
        onChange={() => props.onChange(!props.isChecked)}
        data-hook={DH.PaymentMethod.CreditCard.SaveCard.Checkbox}
      />
      {props.deviceType === 'desktop' && (
        <Tooltip
          className={classes.tooltip}
          data-hook={DH.PaymentMethod.CreditCard.SaveCard.Tooltip}
          content={<span>{t('cc.saveCard.tooltipInfo')}</span>}
          placement="top"
        >
          <span className={classes.tooltipIcon}>
            <InfoCircle />
          </span>
        </Tooltip>
      )}
    </div>
  );
SaveCardCheckboxView.displayName = 'SaveCardCheckboxView';
